export default __webpack_public_path__ + "static/google-pub-sub-043088afe6d861fc9c60a640e4410562.svg";